var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveBannersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#4B9BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6429 14.1428H13.3571C12.0553 14.1428 11 15.1981 11 16.5V27.4999C11 28.8018 12.0553 29.8571 13.3571 29.8571H30.6429C31.9447 29.8571 33 28.8018 33 27.4999V16.5C33 15.1981 31.9447 14.1428 30.6429 14.1428ZM31.4285 23.2461L26.4841 18.3016C26.1773 17.9949 25.6799 17.9949 25.3731 18.3016L18.8572 24.8175L16.2698 22.2301C15.963 21.9234 15.4656 21.9234 15.1588 22.2301L12.5714 24.8175V16.5C12.5714 16.066 12.9232 15.7142 13.3571 15.7142H30.6429C31.0768 15.7142 31.4286 16.066 31.4286 16.5V23.2461H31.4285Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.071 22C19.3728 22 20.4282 20.9447 20.4282 19.6429C20.4282 18.3411 19.3728 17.2858 18.071 17.2858C16.7692 17.2858 15.7139 18.3411 15.7139 19.6429C15.7139 20.9447 16.7692 22 18.071 22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveBannersIcon);
export default __webpack_public_path__ + "static/media/active-banners-icon.229ab92e72f57ff0bf68b0c0023c4c07.svg";
export { ForwardRef as ReactComponent };